// extracted by mini-css-extract-plugin
export default {"loginButton":"RegisterSuccess_loginButton__ioMW5","description":"RegisterSuccess_description__CxmdX"};